import React from "react";
import CryptoJS from "crypto-js";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import ReactTable from "react-table";
import CardBody from "components/Card/CardBody.jsx";
import { PulseLoader } from "react-spinners";
import API from "@aws-amplify/api";
import withStyles from "@material-ui/core/styles/withStyles";
import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Cookies from "universal-cookie";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "components/CustomButtons/Button.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import LoadingOverlay from "react-loading-overlay";
import { css } from "react-emotion";
import "assets/scss/styles.css";
import SweetAlert from "react-bootstrap-sweetalert";
import Switch from "@material-ui/core/Switch";
import Datetime from "react-datetime";
import { yellow } from "@material-ui/core/colors";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Select from "react-select";
import FormControl from "@material-ui/core/FormControl";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Slide from "@material-ui/core/Slide";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import PropTypes from "prop-types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
function Transition(props) {
  return <Slide direction="down" {...props} />;
}
let apiName = process.env.REACT_APP_AMPLIFY_API;
var yesterday = Datetime.moment().subtract(1, "day");
let dateValid = function(current) {
  return current.isAfter(yesterday);
};
class ViewDeliveries extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editAutomationName: "",
      fullDeliveryObj: {},
      editDeliveryModal: false,
      startDatetimestamp: 0,
      endDatetimestamp: 0,
      loading: true,
      deliveriesData: [],
      errors: {},
      showCountsAlert: null,
      localStorageClientId: "",
    };
  }
  startDate(event) {
    let tt = Date.parse(Datetime.moment(event.target.value).format()) / 1000;
    this.setState({ startDatetimestamp: tt });
  }
  endDate(event) {
    let tt = Date.parse(Datetime.moment(event.target.value).format()) / 1000;
    this.setState({ endDatetimestamp: tt });
  }
  copyDeliveryId(listId) {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = listId;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  }
  numberWithCommas(x) {
    return x != undefined
      ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : "";
  }
  showCounts(countsArr, id) {
    let filterChannel = countsArr.filter((x) => x.channelId == id);
    let disMessageC = "";
    let disMessageE = "";
    if (filterChannel.length == 1) {
      disMessageC =
        disMessageC +
        "Customers: " +
        this.numberWithCommas(
          filterChannel[0]["counts"][0]["customers"]["marketable"]
        );
      disMessageE =
        disMessageE +
        "Email Addresses: " +
        this.numberWithCommas(
          filterChannel[0]["counts"][0]["email_addresses"]["marketable"]
        );
    }
    this.setState({
      showCountsAlert: (
        <SweetAlert
          style={{
            display: "block",
            marginTop: "-100px",
            textTransform: "none",
          }}
          title={"Quantity"}
          onConfirm={() => this.setState({ showCountsAlert: null })}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          confirmBtnText="Close"
        >
          <h2
            style={{
              paddingLeft: "22px",
              textAlign: "left",
              float: "center",
              color: "#417a94",
              paddingBottom: "20px",
            }}
          >
            {disMessageC} <br /> {disMessageE}
          </h2>
        </SweetAlert>
      ),
    });
  }
  saveDelivery() {
    if (this.state.startDatetimestamp >= this.state.endDatetimestamp) {
      let err = {};
      err["daterangeErr"] = "Please enter valid date range";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["daterangeErr"] = ""),
          });
        }.bind(this),
        3000
      );
    } else {
      let tempPushObj = this.state.fullDeliveryObj;
      tempPushObj["responseSettings"]["start"] = this.state.startDatetimestamp;
      tempPushObj["responseSettings"]["end"] = this.state.endDatetimestamp;
      fetch(
        "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/deliveries",
        {
          method: "post",
          body: JSON.stringify(tempPushObj),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          this.setState({ editDeliveryModal: false });
          this.fetchAllDeliveries();
        });
    }
  }
  setChecked(e, delId) {
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/deliveries",
      {
        method: "get",
        headers: { id: delId },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if ("Items" in result) {
          if (result["Items"].length > 0) {
            let selectedDid = result["Items"][0];
            selectedDid["responseSettings"]["excluded"] = e;
            fetch(
              "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/deliveries",
              {
                method: "post",
                body: JSON.stringify(selectedDid),
              }
            )
              .then((res) => res.json())
              .then((result) => {
                this.fetchAllDeliveries();
              });
          }
        }
      });
  }
  editDeliveries(dId) {
    this.setState({ deliveryId: dId });
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/deliveries",
      {
        method: "get",
        headers: { id: dId },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if ("Items" in result) {
          if (result["Items"].length > 0) {
            this.setState({
              editAutomationName: this.state.deliveriesData.filter(
                (x) => x.automationId == result["Items"][0]["automationId"]
              )[0]["automationName"],
            });
            this.setState({ fullDeliveryObj: result["Items"][0] });
            this.setState({
              startDatetimestamp:
                result["Items"][0]["responseSettings"]["start"],
            });
            this.setState({
              endDatetimestamp: result["Items"][0]["responseSettings"]["end"],
            });
            this.setState({ editDeliveryModal: true });
          }
        }
      });
  }
  fetchAllDeliveries() {
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/deliveries",
      {
        method: "get",
        headers: {
          cId: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          if ("Items" in result) {
            let deliveriesResponse = result["Items"].sort(
              (a, b) => (a.createdAt < b.createdAt ? 1 : -1)
            );
            for (let i in deliveriesResponse) {
              deliveriesResponse[i]["createdAt"] =
                new Date(
                  deliveriesResponse[i]["createdAt"] * 1000
                ).toLocaleDateString() +
                " " +
                new Date(
                  deliveriesResponse[i]["createdAt"] * 1000
                ).toLocaleTimeString();
              deliveriesResponse[i]["completedAt"] =
                new Date(
                  deliveriesResponse[i]["completedAt"] * 1000
                ).toLocaleDateString() +
                " " +
                new Date(
                  deliveriesResponse[i]["completedAt"] * 1000
                ).toLocaleTimeString();
              deliveriesResponse[i]["start"] =
                // Modified the code for Goodwill requirement where in we show the campaign start date
                // new Date(
                //   deliveriesResponse[i]["responseSettings"]["start"] * 1000
                // ).toLocaleDateString() +
                // " " +
                // new Date(
                //   deliveriesResponse[i]["responseSettings"]["start"] * 1000
                // ).toLocaleTimeString();
                this.state.localStorageClientId ===
                "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
                  ? new Date(
                      deliveriesResponse[i]["campaignStartDate"] * 1000
                    ).toLocaleDateString() +
                    " " +
                    new Date(
                      deliveriesResponse[i]["campaignStartDate"] * 1000
                    ).toLocaleTimeString()
                  : new Date(
                      deliveriesResponse[i]["responseSettings"]["start"] * 1000
                    ).toLocaleDateString() +
                    " " +
                    new Date(
                      deliveriesResponse[i]["responseSettings"]["start"] * 1000
                    ).toLocaleTimeString();
              deliveriesResponse[i]["end"] =
                // Modified the code for Goodwill requirement where in we show the campaign end date
                // new Date(
                //   deliveriesResponse[i]["responseSettings"]["end"] * 1000
                // ).toLocaleDateString() +
                // " " +
                // new Date(
                //   deliveriesResponse[i]["responseSettings"]["end"] * 1000
                // ).toLocaleTimeString();
                this.state.localStorageClientId ===
                "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
                  ? new Date(
                      // deliveriesResponse[i]["responseSettings"]["end"] * 1000
                      deliveriesResponse[i]["campaignEndDate"] * 1000
                    ).toLocaleDateString() +
                    " " +
                    new Date(
                      // deliveriesResponse[i]["responseSettings"]["end"] * 1000
                      deliveriesResponse[i]["campaignEndDate"] * 1000
                    ).toLocaleTimeString()
                  : new Date(
                      deliveriesResponse[i]["responseSettings"]["end"] * 1000
                      // deliveriesResponse[i]["campaignEndDate"] * 1000
                    ).toLocaleDateString() +
                    " " +
                    new Date(
                      deliveriesResponse[i]["responseSettings"]["end"] * 1000
                      // deliveriesResponse[i]["campaignEndDate"] * 1000
                    ).toLocaleTimeString();
              deliveriesResponse[i]["excluded"] = (
                <div className="actions-center">
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={
                          deliveriesResponse[i]["responseSettings"]["excluded"]
                        }
                        onChange={(event) =>
                          this.setChecked(
                            event.target.checked,
                            deliveriesResponse[i]["id"]
                          )
                        }
                      />
                    }
                  />
                </div>
              );
              deliveriesResponse[i]["actions"] = (
                <div className="actions-right">
                  <Tooltip title="Edit">
                    <Button
                      justIcon
                      color="success"
                      onClick={() =>
                        this.editDeliveries(deliveriesResponse[i]["id"])
                      }
                    >
                      <i
                        style={{ fontSize: "14px" }}
                        className={"fa fa-edit fa-1x"}
                      />
                    </Button>
                  </Tooltip>
                  <Tooltip title="Quantity">
                    <Button
                      justIcon
                      style={{ "background-color": "#69ff45" }}
                      onClick={() =>
                        this.showCounts(
                          deliveriesResponse[i]["audienceCount"],
                          deliveriesResponse[i]["channelId"]
                        )
                      }
                    >
                      <i
                        style={{ fontSize: "14px" }}
                        className={"fa fa-certificate fa-1x"}
                      />
                    </Button>
                  </Tooltip>
                  {/*<Tooltip title="Delete">
                            <Button
                                justIcon
                                color="danger"
                                onClick={() =>
                                    this.warningWithConfirmMessage(
                                        deliveriesResponse[i]['id']
                                    )
                                }
                            >
                            <i
                                style={{ fontSize: "14px" }}
                                className={"fa fa-trash fa-1x"}
                            />
                            </Button>
                              </Tooltip>
                        <Tooltip title="Copy delivery id">
                            <Button
                              justIcon
                              color="warning"
                              onClick={() => 
                                this.copyDeliveryId(
                                  deliveriesResponse[i]['id']
                                )
                              }
                            >
                              <i
                                style={{ fontSize: "14px" }}
                                className={"fa fa-copy fa-1x"}
                              />
                            </Button>
                        </Tooltip>*/}
                </div>
              );
            }
            this.setState({ deliveriesData: deliveriesResponse });
            this.setState({ loading: false });
          }
        },
        (error) => {}
      );
  }

  addFilterPlaceholder = () => {
    const filters = document.querySelectorAll("div.rt-th > input");
    for (let filter of filters) {
      filter.placeholder = "Search";
    }
  };

  //function to sort the results
  filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    return row[id] !== undefined
      ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
      : true;
  };

  componentDidMount() {
    this.addFilterPlaceholder();
    this.fetchAllDeliveries();
    this.setState({
      localStorageClientId: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ),
    });
  }
  render() {
    const { classes } = this.props;
    let showSpinner =
      this.state.loading === true ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div
              style={{ textAlign: "center", marginTop: "20px", width: "100%" }}
            >
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: "50px" }}
              />
            </div>
          </GridItem>
        </GridContainer>
      ) : (
        "No records found"
      );
    return (
      <div className="audiencelistwrap">
        {this.state.showCountsAlert}
        <GridContainer style={{ paddingTop: "1em" }}>
          {this.state.alert}
          <GridItem xs={12} sm={12} md={3} />
          <GridItem xs={12}>
            <Card>
              <CardHeader color="warning" icon>
                <CardIcon color="warning">
                  <Assignment />
                </CardIcon>
                <h4 style={{ color: "#0c3c54" }}>Deliveries</h4>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data={this.state.deliveriesData}
                  filterable
                  defaultFilterMethod={(filter, row) =>
                    this.filterCaseInsensitive(filter, row)
                  }
                  columns={[
                    {
                      Header: "Campaign",
                      accessor: "campaignName",
                    },
                    {
                      Header: "Audience",
                      accessor: "audienceTitle",
                    },
                    {
                      Header: "Automation",
                      accessor: "automationName",
                    },
                    {
                      Header: "Program",
                      accessor: "program",
                    },
                    {
                      Header: "Completed",
                      accessor: "completedAt",
                    },
                    /*{
                    Header: "Created",
                    accessor: "createdAt"
                },*/
                    {
                      Header: "Starts",
                      accessor: "start",
                    },
                    {
                      Header: "Ends",
                      accessor: "end",
                    },
                    {
                      Header: "Excludes from Reporting",
                      accessor: "excluded",
                      sortable: false,
                      filterable: false,
                    },
                    {
                      Header: "Status",
                      accessor: "status",
                      sortable: false,
                      filterable: false,
                    },
                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                    },
                  ]}
                  defaultPageSize={10}
                  //showPaginationTop
                  showPaginationBottom={true}
                  noDataText={showSpinner}
                  className="-striped -highlight"
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <center>
          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={this.state.editDeliveryModal}
            TransitionComponent={Transition}
            keepMounted
            disableBackdropClick
            disableEscapeKeyDown
            onClose={() => this.setState({ editDeliveryModal: false })}
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
          >
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{
                backgroundColor: "#92B54B",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                width: "800px",
              }}
            >
              <h4 className={classes.modalTitle} style={{ color: "#fff" }}>
                <b> Edit Delivery </b>
              </h4>
            </DialogTitle>
            <DialogContent
              id="classic-modal-slide-description"
              className={classes.modalBody}
            >
              <div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4>
                      <b>
                        <i>{this.state.editAutomationName}</i>
                      </b>
                    </h4>
                    <br />
                    <form className={classes.container} noValidate>
                      <TextField
                        isValidDate={dateValid}
                        id="datetime-local"
                        label="Start date"
                        type="datetime-local"
                        //defaultValue="2017-05-24T10:30"
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          Datetime.moment(
                            new Date(
                              this.state.startDatetimestamp * 1000
                            ).toLocaleDateString()
                          ).format("YYYY-MM-DD") +
                          "T" +
                          new Date(this.state.startDatetimestamp * 1000)
                            .getHours()
                            .toLocaleString("en-US", {
                              minimumIntegerDigits: 2,
                              useGrouping: false,
                            }) +
                          ":" +
                          new Date(this.state.startDatetimestamp * 1000)
                            .getMinutes()
                            .toLocaleString("en-US", {
                              minimumIntegerDigits: 2,
                              useGrouping: false,
                            })
                        }
                        onChange={this.startDate.bind(this)}
                      />
                    </form>
                    <br />
                    <br />
                    <form className={classes.container} noValidate>
                      <TextField
                        isValidDate={dateValid}
                        id="datetime-local"
                        label="End date"
                        type="datetime-local"
                        //defaultValue="2017-05-24T10:30"
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          Datetime.moment(
                            new Date(
                              this.state.endDatetimestamp * 1000
                            ).toLocaleDateString()
                          ).format("YYYY-MM-DD") +
                          "T" +
                          new Date(this.state.endDatetimestamp * 1000)
                            .getHours()
                            .toLocaleString("en-US", {
                              minimumIntegerDigits: 2,
                              useGrouping: false,
                            }) +
                          ":" +
                          new Date(this.state.endDatetimestamp * 1000)
                            .getMinutes()
                            .toLocaleString("en-US", {
                              minimumIntegerDigits: 2,
                              useGrouping: false,
                            })
                        }
                        onChange={this.endDate.bind(this)}
                      />
                    </form>
                    <span className="redColor">
                      {this.state.errors["daterangeErr"]}
                    </span>
                    <br />
                  </GridItem>
                </GridContainer>
              </div>
            </DialogContent>
            <DialogActions className={classes.modalFooter}>
              <Button
                onClick={() => this.setState({ editDeliveryModal: false })}
                className="btn btncreate"
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                className="btn btncreate"
                color="secondary"
                onClick={() => {
                  this.saveDelivery();
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </center>
      </div>
    );
  }
}
ViewDeliveries.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(notificationsStyle)(ViewDeliveries);



// WEBPACK FOOTER //
// ./src/views/Deliveries/ViewDeliveries.jsx